export enum LoginRoutes {
    select_location = '/login/select-location',
    enter_code = '/login/enter-code',
    email_login = '/login/email-login',
    password_login = '/login/password-login',
    recover_pass = '/login/recover-password',
    location_selected = '/login/location-selected',
    welcome = '/login',
}
